import { render, staticRenderFns } from "./airway-bill-query.vue?vue&type=template&id=14c5871b&scoped=true&"
import script from "./airway-bill-query.vue?vue&type=script&lang=js&"
export * from "./airway-bill-query.vue?vue&type=script&lang=js&"
import style0 from "./airway-bill-query.vue?vue&type=style&index=0&id=14c5871b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c5871b",
  null
  
)

export default component.exports